import { render, staticRenderFns } from "./EmployeeRow.vue?vue&type=template&id=0a4dd418&scoped=true&"
import script from "./EmployeeRow.vue?vue&type=script&lang=js&"
export * from "./EmployeeRow.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRow.vue?vue&type=style&index=0&id=0a4dd418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4dd418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
